import React from 'react'
import { Route } from 'react-router-dom'
import ModalityDashboard from './dashboards/modality/TempSample'
import DevicesDashboard from './dashboards/modality/Devices'
import ModalityMap from './modality-map'
import Utilization from './utilization'
import Financial from './financial'
import AuditPage from './audit/AuditPage'

export default [
  <Route exact path='/audit' component={AuditPage} />,
  <Route exact path='/modalities/dashboard' component={ModalityDashboard} />,
  <Route
    exact
    path='/modalities/devices-dashboard'
    component={DevicesDashboard}
  />,

  // <Route exact path="/modalities/tube-analysis" component={ModalityTubeAnalysis} />,

  <Route exact path='/modalities/map' component={ModalityMap.map} />,
  <Route exact path='/utilization' component={Utilization.home} />,
  <Route exact path='/financial' component={Financial.home} />
]
